/**
 * Ранняя реплика жителя (владелец 2026-11-04): сервер присылает её по SSE, как только модель её написала, не дожидаясь
 * подсказок и слов. Поток уведомлений не знает про игру, игра — про поток: связывает их этот маленький канал.
 */
export interface TalkPreview {
  /** Разговор: `talk_id` или `run_id` миссии. */
  talkId: string;
  /** Что сказал ученик: у голосового ответа это первый раз, когда фраза известна экрану. */
  me: string;
  en: string;
  ru: string | null;
  emo: number;
  audio: string | null;
  action_ru: string | null;
  reaction_ru: string | null;
}

type Listener = (preview: TalkPreview) => void;

const listeners = new Set<Listener>();

export function emitTalkPreview(preview: TalkPreview): void {
  listeners.forEach((listener) => listener(preview));
}

export function onTalkPreview(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
